import { qportalApi } from './qportal-api';
import { convertModelToFormData } from './helpers';
const createUserContract = (contract) => {
    const formData = convertModelToFormData(contract);
    return qportalApi.postForm('UserContract', formData);
};
const updateUserContract = (contract) => {
    const formData = convertModelToFormData(contract);
    return qportalApi.postForm('UserContract/Update', formData);
};
const getUserContractById = (id) => {
    return qportalApi.get(`UserContract/${id}`);
};
const getUserContractsByFreelancer = (freelancerId) => {
    return qportalApi.get(`UserContract/ByFreelancer/${freelancerId}`);
};
const getMyUserContracts = () => {
    return qportalApi.get('UserContract/Mine');
};
const getInternalDepartmentOptions = () => qportalApi.get('UserContract/InternalDepartmentOptions');
const getUserContractSigningUrl = (contractId) => {
    return qportalApi.get(`UserContract/${contractId}/SigningUrl`);
};
const generateUserContractAutoContract = (freelancerId, contactStartDate, contactEndDate, contractAutoGeneratedType, internalDepartmentId) => {
    const formData = new FormData();
    formData.append('freelancerId', freelancerId);
    formData.append('contactStartDate', contactStartDate);
    formData.append('contactEndDate', contactEndDate);
    formData.append('contractAutoGeneratedType', contractAutoGeneratedType.toString());
    formData.append('internalDepartmentId', internalDepartmentId);
    return qportalApi.post('UserContract/GenerateAutoContract', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};
const UserContractApi = {
    createUserContract,
    updateUserContract,
    getUserContractById,
    getUserContractsByFreelancer,
    getMyUserContracts,
    getInternalDepartmentOptions,
    getUserContractSigningUrl,
    generateUserContractAutoContract
};
export default UserContractApi;
